import { useContext } from 'react'

import { isUIDevRoute } from 'helpers/miscellaneous'

import { VideoContext } from '../../components/VideoProvider'

export default function useVideoContext() {
    const context = useContext(VideoContext)
    if (!context) {
        /* Don't throw errors in /ui route */
        if (isUIDevRoute) return {}

        throw new Error('useVideoContext must be used within a VideoProvider')
    }
    return context
}
